// extracted by mini-css-extract-plugin
export default {"center":"CodeVerification_center__nuSIh"};